export default __webpack_public_path__ + "static/media/3081.ae92afac.jpg";